export default "__VITE_ASSET__Dvk12LI$__"